import { fetchWrapper, objectToQueryParams } from '../utils';

export class moderator {
  static baseUrl = process.env.REACT_APP_BASE_API + 'moderator/orders';

  static async create(form) {
    return await fetchWrapper.post(this.baseUrl, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findAllFinished(filters) {
    const url = `${this.baseUrl}/finished?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadAllFinished(filters) {
    const url = `${this.baseUrl}/finished/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findUsers(filters) {
    const url = `${this.baseUrl}/users?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findRoutes(filters) {
    const url = `${this.baseUrl}/routes?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findVehicles(filters) {
    const url = `${this.baseUrl}/vehicles?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async import(form) {
    const url = `${this.baseUrl}/import`;
    return await fetchWrapper.post(url, form);
  }

  static async downloadTemplate() {
    const url = `${this.baseUrl}/template`;
    return await fetchWrapper.get(url);
  }

  static async reassignment(form) {
    const url = `${this.baseUrl}/reassignment`;
    return await fetchWrapper.post(url, form);
  }

  static async duplicateDate(form) {
    const url = `${this.baseUrl}/duplicate-date`;
    return await fetchWrapper.post(url, form);
  }
}
